import { Schema } from 'effect';

import { GtmItemsArraySchema } from './items';
import { Number } from '../primitive/number';
import { StringRequired } from '../primitive/string';

/**
 * https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtm#add_or_remove_an_item_from_a_shopping_cart
 */
export const GtmRemoveFromCartEventSchema = Schema.Struct({
  event: Schema.Literal('track.remove_from_cart'),
  ecommerce: Schema.Struct({
    currency: StringRequired,
    value: Number,
    items: GtmItemsArraySchema,
  }),
}).annotate({ identifier: 'GtmRemoveFromCartEventSchema' });

export type GtmRemoveFromCartEvent = Schema.Schema.Type<typeof GtmRemoveFromCartEventSchema>;
